<template>
  <v-container class="default-layout fill-height pa-0">
    <v-row class="fill-height" justify="center">
      <v-col cols="1" v-if="loading">
        <v-progress-circular indeterminate color="primary" class="default-layout__loading" />
      </v-col>
      <template v-else>
        <v-col cols="12" class="pa-0">
          <router-view />
        </v-col>
      </template>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor" location="top right">
      {{ snackbarMessage }}
    </v-snackbar>
  </v-container>
</template>

<script setup lang="ts">
import { onMounted, provide, ref } from 'vue'
import { useRouter } from 'vue-router'

import { useAppStore } from '@/stores/app'
import AppService from '@/services/appService'
import { roles } from '@/constants/roles'

const router = useRouter()
const appStore = useAppStore()
const appService = new AppService()

const user = ref(appStore.user)
const portal = ref(appStore.portal)
const snackbar = ref<boolean>(false)
const snackbarMessage = ref()
const snackbarColor = ref()

const loading = ref(true)

const init = async () => {
  const businessProfiles = await appService.getPortalBusinessProfiles(
    user.value?.id,
    portal.value?.id,
  )
  appStore.setBusinessProfiles(businessProfiles)

  if (appStore.embedUser?.isNewUserCreated && appStore.embedUser?.brandId) {
    appStore.setSelectedBusinessProfileId(appStore.businessProfiles[0].id)

    await appService.assignDivisionBrandsToClient(
      appStore.selectedBusinessProfileId,
      [appStore.embedUser?.brandId],
      roles.STUNNR_BE_CLIENT_ACCESS,
    )
  }

  if (router.currentRoute.value.name === 'Default' && appStore.businessProfiles.length == 1) {
    appStore.setSelectedBusinessProfileId(appStore.businessProfiles[0].id)
    router.push({
      name: 'App',
      params: { businessProfileId: appStore.businessProfiles[0].id },
    })
  } else if (router.currentRoute.value.name === 'Default') {
    router.push({ name: 'ProfileSelection' })
  }

  loading.value = false
}

const notify = (message: string, color: string) => {
  snackbar.value = true
  snackbarMessage.value = message
  snackbarColor.value = color
}

onMounted(() => {
  init()
})

provide('notify', notify)
</script>

<style scoped lang="scss">
.default-layout {
  max-height: 100vh;
  max-width: 100vw;
  overflow: hidden;
  align-items: flex-start !important;

  > .v-row {
    margin: 0;
  }
}
</style>
